<template>
  <v-dialog
    :value="dialog"
    :max-width="400"
    persistent
    :retain-focus="false"
    @keydown.esc="escape(closeDialog)"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ dialogTitle }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
          <v-container>
            <v-row dense align="center" justify="end">
              <v-col>
                <v-text-field
                  type="text"
                  v-model.trim="editedLabel.name"
                  :rules="rules.name"
                  tabindex="1"
                  autofocus
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn text tabindex="3" @click="closeDialog">{{ $t('cancel') }}</v-btn>
        <v-btn text color="primary" tabindex="2" :disabled="!isModelChanged()" @click="submit">{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

import PBtnIcon from '@/components/PBtnIcon'

import snackbarMixin from '@/mixins/snackbar.mixin'
import objectMixin from '@/mixins/object.mixin'
import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'
import errorMixin from '@/mixins/error.mixin'


export default {
  components: {
    PBtnIcon
  },


  mixins: [
    snackbarMixin,
    objectMixin,
    dialogMixin,
    validationMixin,
    unsavedChangesMixin,
    errorMixin
  ],


  props: {
    label: Object
  },


  data () {
    return {
      editedLabel: {},
      defaultLabel: {
        name: ''
      },
      existingLabelNames: []
    }
  },


  computed: {
    dialogTitle () {
      return this.label ? this.$t('label.editLabel') : this.$t('label.createLabel')
    },

    rulesToApply () {
      const rule = this.rule

      return {
        name: [
          rule.required(),
          rule.unique(this.existingLabelNames, this.$t('label.nameExists'))
        ]
      }
    }
  },


  methods: {
    ...mapActions('contactLabel', ['createContactLabel', 'updateContactLabel']),

    onDialogOpen () {
      this.existingLabelNames = []
      this.editedLabel = this.getObjectCopy(this.label || this.defaultLabel)
      this.initWatchedModel(this.editedLabel)
      this.resetValidation()
    },

    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid || !this.isModelChanged()) return

      try {
        this.showSnackbarProcessing()
        const label = this.getObjectCopy(this.editedLabel)

        if (label.id) {
          await this.updateContactLabel(label)
          this.showSnackbarSuccess(this.$t('label.labelUpdated'))
        } else {
          await this.createContactLabel(label)
          this.showSnackbarSuccess(this.$t('label.labelCreated'))
        }

        this.closeDialog()
      } catch (error) {
        if (this.is409ConflictError(error)) {
          this.hideSnackbar()
          this.existingLabelNames.push(this.editedLabel.name)
          this.validate(this.rulesToApply)
        } else {
          this.showSnackbarError()
        }
        this.$log.error(error)
      }
    }
  }
}
</script>
